import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartReport = _resolveComponent("ChartReport")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, { spinning: _ctx.chartLoading }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        class: _normalizeClass(_ctx.$style['service-report__chart']),
        gutter: [10, 5]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_ChartReport, {
                ref: "chartRef",
                options: _ctx.options,
                isEmpty: _ctx.isEmpty,
                autoResize: true,
                updateOption: _ctx.updateOption
              }, null, 8, ["options", "isEmpty", "updateOption"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["spinning"]))
}